export default __webpack_public_path__ + "static/media/lasAngelesRamsVideo-2x.688bfece.jpg";